import gql from 'graphql-tag';

export default gql`
    mutation EditStages($input: EditStagesInput) {
        editStages(input: $input) {
            errors
        }
    }
`;
